import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styles from './NotFoundPage.module.css';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className={styles.wrap}>
      <div className={styles.title}>{t('notFound.title')}</div>
      <Link to="/" className={styles.link}>
        {t('notFound.home')}
      </Link>
    </div>
  );
}
